<div class="w-100 mt-5 d-flex flex-column">
  <h5 class="title_2 mb-0">{{ "PROCESSES.ACCOMMODATION.PAYMENT.METHOD" | translate }}</h5>


  <mat-tab-group (selectedTabChange)="changeTab($event)" [selectedIndex]="tabNumber" animationDuration="0ms"
                 class="lf-tab payment-tab" preserveContent>
    <mat-tab>
      <ng-template mat-tab-label>
        <div class="h-100 w-100 py-2 px-4">
          <lf-icon height="24px" name="{{ tabNumber == 0 ? 'creditCardWhite' : 'creditCardBlack' }}"
                   width="24px"></lf-icon>
        </div>
      </ng-template>
      <div class="position-relative mt-4">
        <mat-form-field class="pb-0 w-100">
          <span class="font-12 fw-bold">{{ 'PROCESSES.ACCOMMODATION.PAYMENT.CARDOWNER' | translate }}</span>
          <input [formControl]="paymentForm.controls.cardOwner" class="text_3 fw-bold" matInput type="text"
            placeholder="{{ 'PROFILE.LASTNAME' | translate }} {{ 'PROFILE.FIRSTNAME' | translate }}">
        </mat-form-field>
        <span
          *ngIf="isPaymentFormSubmitted && paymentForm.controls.cardOwner.errors && paymentForm.controls.cardOwner.errors.required"
          class="red-error minitext_2">
        {{ "COMMON.IS_REQUIRED" | translate }}
      </span>
        <div *ngIf="paymentForm.value.cardOwner && !paymentForm.controls.cardOwner.errors"
          class="position-absolute text-success d-flex align-items-center font-12">
          <span class="material-icons-outlined font-12 me-1">done</span>
          {{ 'COMMON.OK_CHECKED' | translate }}
        </div>
      </div>

      <div *ngIf="isLoading" class="flex-grow-1 d-flex align-items-center justify-content-center mb-1">
        <div class="spinner-border text-primary"></div>
      </div>

      <div (ngSubmit)="pay()" *ngIf="!isLoading && tabNumber === 0" [elementsOptions]="elementsOptions"
        [formGroup]="stripeTest" ngxStripeCardGroup>
        <form>
          <div class="w-100 position-relative">
            <span class="form-label-color rescale subtitle_1 text-black">Numéro de carte</span>
            <ngx-stripe-card-number [options]="cardOptions" class="stripe-form-control">
            </ngx-stripe-card-number>
            <span *ngIf="stripeError && stripeError.code === 'incomplete_number'" class="text-danger minitext_2">
              {{stripeError.message}}
            </span>
          </div>
          <div class="d-flex flex-row mt-5 pt-1">
            <div class="w-50 position-relative">
              <span class="form-label-color rescale subtitle_1 text-black">Date d'expiration</span>
              <ngx-stripe-card-expiry [options]="cardOptions" class="stripe-form-control">
              </ngx-stripe-card-expiry>
              <span *ngIf="stripeError && stripeError.code === 'incomplete_expiry'" class="text-danger minitext_2">
                {{stripeError.message}}
              </span>
            </div>
            <div class="w-50 position-relative">
              <span class="form-label-color rescale subtitle_1 text-black">CVC</span>
              <ngx-stripe-card-cvc [options]="cardOptions" class="stripe-form-control">
              </ngx-stripe-card-cvc>
              <span *ngIf="stripeError && stripeError.code === 'incomplete_cvc'" class="text-danger minitext_2">
                {{stripeError.message}}
              </span>
            </div>
          </div>

        </form>
      </div>

      <div
        *ngIf="stripeError && (!['incomplete_cvc', 'incomplete_expiry', 'incomplete_number'].includes(stripeError.code))"
        class="mt-3 border border-danger text_3 px-4 py-3 w-fit-content">
        <div class="text-danger">
          {{stripeError.message}}
        </div>
        <p class="txt-darkGray mt-2">
          {{'COMMON.PAYMENT.SUGGEST_PAYPAL' | translate}}
          <span (click)="changeTab({index: 1})" class="text-underlined pointer fw-bold">Paypal</span>.
        </p>
      </div>

      <div class="mediumGray font-10 mt-5 d-flex align-items-center">
        <span [innerHTML]="'COMMON.PAYEMENT.SECURE.TEXT_1' | translate"></span>
        <span class="material-icons-outlined font-12 ms-1 align-middle">lock</span>
      </div>
      <p class="lightGray2 font-10">{{ "COMMON.PAYEMENT.SECURE.TEXT_2" | translate }}</p>
      <div class="d-flex flex-row mt-2 flex-wrap gap-8">
        <img *ngFor="let cardImg of creditCardArray" alt="{{cardImg}}" class="border br-6"
             src="assets/img/CreditCard/{{ cardImg }}.png">
      </div>
    </mat-tab>


    <mat-tab>
      <ng-template mat-tab-label>
        <div [ngClass]="{'highlighted': stripeError && (!['incomplete_cvc', 'incomplete_expiry', 'incomplete_number'].includes(stripeError.code))}"
             class="h-100 w-100 py-2 px-4">
          <lf-icon height="24px" name="{{ tabNumber == 1 ? 'paypalWhite' : 'paypalBlack' }}" width="24px"></lf-icon>
        </div>
      </ng-template>

      <div class="d-flex flex-column gap-8 mt-3">
        <app-paypal-button *ngIf="tabNumber == 1" [amount]="price" [booking]="booking" [itemName]="service"
          [nextUrl]="nextUrl" [pdfKey]="pdfKey" [process]="process"
          [promoCode]="promoCode" [room]="room"></app-paypal-button>
      </div>
    </mat-tab>
  </mat-tab-group>

</div>
